import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { FaFacebookSquare } from "react-icons/fa";

import { FaXTwitter, FaYoutube, FaInstagram } from "react-icons/fa6";
import logoj from "../assets/logoj.svg";
import Chatbot from "./bot/Chatbot";

const socialIcons = [
  {
    href: "https://www.facebook.com/profile.php?id=61573062566270",
    icon: <FaFacebookSquare className="w-5 h-5" />,
    name: "Facebook",
  },
  {
    href: "https://www.instagram.com/jaano.ai/",
    icon: <FaInstagram className="w-5 h-5" />,
    name: "Instagram",
  },
  {
    href: "https://x.com/Jaano_ai",
    icon: <FaXTwitter className="w-5 h-5" />,
    name: "Twitter",
  },
  {
    href: "https://www.youtube.com/@Jaano_ai",
    icon: <FaYoutube className="w-5 h-5" />,
    name: "YouTube",
  },
];

// const JaanoChatbot = () => {
//   useEffect(() => {
//     // Set up the configuration
//     window.embeddedChatbotConfig = {
//       chatbotId: "423d4a5d-b3da-4572-a1d7-ee89c5008b36",
//       userId: "b5da7488-af0c-4098-a925-d52db45cb46b",
//       domain: "https://jaano.ai",
//       queryexpanstion: false,
//       reranking: true,
//       clor: "#800f7c",
//       position: "bottomRight",
//     };

//     // Inject the chatbot script
//     const script = document.createElement("script");
//     script.src = "https://jaano.ai/chatbot-embedding.js";
//     // script.src = "http://localhost:3000/chatbot-embedding.js";
//     script.defer = true;
//     document.body.appendChild(script);

//     // Optional cleanup (if needed when unmounting)
//     return () => {
//       document.body.removeChild(script);
//     };
//   }, []);

//   return null; // This component only injects the script
// };

const Footer = () => {
  return (
    <motion.footer
      className="bg-white text-black border-t border-gray-200 px-4 sm:px-10 md:px-20 py-12"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}>
      {/* Top Accent Line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-darkprimary"></div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 text-sm sm:text-base">
        {/* Logo and Social */}
        <div className="flex flex-col gap-4">
          <Link to="/" className="flex items-center gap-2">
            <img src={logoj} alt="JAANO.AI" className="h-10" />
          </Link>
          <p className="text-gray-600 text-xs text-xs sm:text-sm md:text-base">
            © 2025 Jaano.ai, Inc.
          </p>
          <div className="flex gap-4 mt-2">
            {socialIcons.map((item, idx) => (
              <motion.a
                key={idx}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full border border-gray-300 hover:bg-gray-100 transition-all duration-200"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                aria-label={item.name}>
                {item.icon}
              </motion.a>
            ))}
          </div>
        </div>

        {/* Product & Company Links */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 text-sm sm:text-base md:text-lg ">
          <div></div>
          <div className="flex flex-col gap-2">
            <h4 className="font-semibold text-gray-800 mb-1">Product</h4>
            <Link to="/pricing" className="hover:text-darkprimary transition">
              Pricing
            </Link>
            <Link to="/support" className="hover:text-darkprimary transition">
              Support
            </Link>
          </div>
          <div className="flex flex-col gap-2">
            <h4 className="font-semibold text-gray-800 mb-1">Company</h4>
            <Link
              to="/legal/privacy"
              className="hover:text-darkprimary transition">
              Privacy Policy
            </Link>
            <Link
              to="/legal/terms"
              className="hover:text-darkprimary transition">
              Terms of Service
            </Link>
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-semibold text-gray-800 mb-1">Resources</h4>
            <Link
              to="/legal/refund"
              className="hover:text-darkprimary transition">
              Refund Policy
            </Link>
            <Link
              to="/legal/ship"
              className="hover:text-darkprimary transition">
              Shipping Policy
            </Link>
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-semibold text-gray-800 mb-1">Documentation</h4>
            <Link to="/doc" className="hover:text-darkprimary transition">
              Jaano Integration
            </Link>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <div className="text-center text-xs sm:text-sm md:text-base text-gray-500 mt-12">
        &copy; {new Date().getFullYear()}{" "}
        <a
          href="https://www.tokenailabs.com/"
          className="hover:underline font-medium"
          target="_blank"
          rel="noopener noreferrer">
          Token Ai Labs Pvt. Ltd.
        </a>{" "}
        All rights reserved.
      </div>
      <Chatbot
        chatbotId="423d4a5d-b3da-4572-a1d7-ee89c5008b36"
        userId="b5da7488-af0c-4098-a925-d52db45cb46b"
        reranking={true}
        queryexpansion={false}
        position="bottomRight"
        color="#800f7c"
      />
    </motion.footer>
  );
};

export default Footer;
